module.exports = __webpack_public_path__ + "img/logo_green.d2ed7208.png";